import React, { Component } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import isEqual from 'react-fast-compare'

import { Tooltip } from 'components'
import { currencyMaker } from 'services/helpers'
import { BookingTableCells, BookingOptions } from 'components/Bookings/components'

export class BookingsTableRowBase extends Component {
  state = {
    isEditing: false
  }

  // eslint-disable-next-line max-len
  bookingInfo = `${this.props.booking.createdDate} | ${this.props.booking.userName}${this.props.booking.company ? " | " + this.props.booking.company : ''}`

  rowClasses = {
    confirmed: this.props.classes.highlightConfirmed,
    noResponse: this.props.classes.highlightNoResponse,
    noPaid: this.props.classes.highlightNotPaid,
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState)
  }

  editBooking = () => this.setState({ isEditing: true })

  submitEditing = () => {
    const { setBooking } = this.props

    setBooking()

    this.setState({ isEditing: false })
  }

  onNumberClick = () => {
    const {
      booking: { from, to, routeName, price, departureTime, ticketDepartureDate, departurePlace, routeType, sourceId },
      bus,
      fromCityTypeByLabel,
      carriagePhones,
      showSnackbar
    } = this.props

    const currency = currencyMaker(fromCityTypeByLabel, price, sourceId)

    // eslint-disable-next-line
    const copyText = `
Квиток для Вас заброньовано на рейс ${routeName || ''} за напрямком ${from || ''} - ${to || ''}. 
Вартість ${price || ''} ${currency}. 
Відправлення з ${departurePlace || ''}, ${ticketDepartureDate || ''} о ${departureTime || ''}. 
Телефон водіїв: ${carriagePhones.join(' | ')}. 
Автобус: ${bus || ''}
    `

    const el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = copyText;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);

    showSnackbar({
      type: 'success',
      message: 'Скопійовано в буфер обміну'
    })
  }

  render() {
    const { isEditing } = this.state
    const { booking, classes, isPartner, index } = this.props

    const { status } = booking

    return (
      <TableRow className={this.rowClasses[status]}>
        <TableCell padding='none' className={classes.tableCell}>
          <BookingOptions
            booking={booking}
            editBooking={this.editBooking}
            submitEditing={this.submitEditing}
            isEditing={isEditing}
          />
        </TableCell>

        <TableCell
          padding='none'
          className={classes.tableCell}
          onClick={this.onNumberClick}
        >
          {isPartner
            ? index + 1
            : (
              <Tooltip title={this.bookingInfo}>
                <div>
                  {index + 1}
                </div>
              </Tooltip>
            )}
        </TableCell>

        <BookingTableCells
          booking={booking}
          from={booking.from}
          isEditing={isEditing}
        />
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsTableRow/BookingsTableRow.js